import createIcon from '../../createIcon';

/**
 * @component @name SignalCellularConnectedNoInternet0Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMThIMjJWMTBIMjBWMThaTTIwIDIySDIyVjIwSDIwVjIyWk0xOCAyMFYyMkgyTDIyIDJWOEgyMFY2LjgzTDYuODMgMjBIMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellularConnectedNoInternet0Bar = createIcon('SignalCellularConnectedNoInternet0Bar', [
  [
    'path',
    {
      d: 'M20 18H22V10H20V18ZM20 22H22V20H20V22ZM18 20V22H2L22 2V8H20V6.83L6.83 20H18Z',
      key: '1gngwj',
    },
  ],
]);

export default SignalCellularConnectedNoInternet0Bar;
